// AI Generated Test
import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'notification',
    standalone: false,
    template: `
        <div class="notification d-flex pt-3 pb-4 pl-6"
             [ngClass]="{'notification-with-link' : notificationWithLink}"
             (click)="goTo()"
             [attr.role]="notificationWithLink ? 'button' : undefined"
             [attr.aria-label]="notificationWithLink ? monAriaButtonText : undefined">
            <div class="mt-2 notification-icon pr-4" *ngIf="faIcon">
                <span class="fa-stack fa-xl" *ngIf="digit === 0">
                    <span class="fa-stack-2x text-grey background-icon" [ngClass]="faIcon" aria-hidden="true"></span>
                    <span class="sr-only">{{monAriaIconText}}</span>
                    <span class="fas fa-stack-1x check-passed" aria-hidden="true"></span>
                    <span class="sr-only" translate>Check passed</span>
                </span>

                <span class="fa-stack fa-xl" *ngIf="digit && digit > 0">
                    <span class="fa-stack-2x" [ngClass]="[faIcon, classColor]"></span>
                </span>
            </div>
            <div [ngClass]="{ 'pl-1': faIcon}">
                <ul class="list-unstyled mb-0">
                    <li class="text-secondary-4">{{ title }}</li>
                    <li class="font-size-1-5 font-weight-300 text-nowrap mt-1">
                        <span *ngIf="!allowDecimal" class="vtop text-secondary-4">{{ digit | monNumber }}</span>
                        <span *ngIf="allowDecimal" class="vtop text-secondary-4">{{ digit | monNumber: "0.00" }}</span>
                        <span class="font-size-0-6 vtop text-secondary-4" [ngClass]="setMiniDigitsColor()" *ngIf="miniDigits">
                            {{ displayPositive(miniDigits) }}
                        </span>
                        <span class="font-size-0-6 vtop text-secondary-4" [ngClass]="setMiniDigitsColor()" [attr.unit]="unit">
                            {{ unit }}
                        </span>
                    </li>
                    <li class="text-secondary-4 mt-2">
                        <ng-content></ng-content>
                    </li>
                </ul>
            </div>
        </div>
    `,
})
export class NotificationComponent implements OnChanges {
    @Input() params?: any;
    @Input() link?: string;
    @Input() faIcon?: string;
    @Input() title?: string;
    @Input() digit: any = 0;
    @Input() allowDecimal?: boolean;
    @Input() classColor?: string;
    @Input() miniDigits?: string;
    @Input() unit?: string;
    @Input() monAriaIconText?: string;
    @Input() monAriaButtonText?: string;

    @Output() callback = new EventEmitter<any>();

    notificationWithLink?: string | null;
    private isFirstChange = true;

    constructor (private stateService: StateService) {}

    ngOnChanges (): void {
        this.unit = this.unit ?? '';
        if (this.digit !== 0 && this.digit !== undefined && this.digit < 1) {
            this.allowDecimal = true;
        }
        if (this.link || this.params) {
            this.notificationWithLink = this.link || this.params?.target;
        } else {
            this.notificationWithLink = null;
        }
    }

    setMiniDigitsColor (): string {
        let result = '';
        if (this.miniDigits && parseFloat(this.miniDigits) < 0) {
            result = 'text-success';
        } else if (this.miniDigits && parseFloat(this.miniDigits) > 0) {
            result = 'text-danger';
        } else if (this.miniDigits === '0') {
            result = 'text-grey';
        }
        return result;
    }

    displayPositive (num: string | undefined): string {
        if (!num) {
            return '';
        }
        let result = num;

        if (parseFloat(num) > 0) {
            result = '+' + result.toString();
        }
        return result !== '0' ? result : '~';
    }

    goTo (): void {
        if (this.link) {
            this.params = this.params || {};
            this.stateService.go(this.link, this.params);
        }
        this.params = this.params || {};
        this.callback.emit({ params: this.params });
    }
}
